import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import localeNlBe from '@angular/common/locales/nl-BE';
import localeDe from '@angular/common/locales/de';
import localeEl from '@angular/common/locales/el';
import localeEs from '@angular/common/locales/es';
import localePl from '@angular/common/locales/pl';
import localeIt from '@angular/common/locales/it';
import localeEnGb from '@angular/common/locales/en-GB';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from '@environments/environment';
import * as Sentry from '@sentry/angular';

registerLocaleData(localeNl);
registerLocaleData(localeNlBe);
registerLocaleData(localeDe);
registerLocaleData(localeEl);
registerLocaleData(localeEs);
registerLocaleData(localePl);
registerLocaleData(localeIt);
registerLocaleData(localeEnGb);

if (environment.sentryUrl) {
  if (environment.name === 'Test' || environment.name === 'Acceptance') {
    Sentry.init({
      dsn: environment.sentryUrl,
      normalizeDepth: 0,
      environment: environment.name,
      ignoreErrors: [
        'Non-Error exception captured',
        'NG0100: ExpressionChangedAfterItHasBeenCheckedError',
      ],
      replaysSessionSampleRate: 0,
      // If the entire session is not sampled, use the below sample rate to sample
      // sessions when an error occurs.
      replaysOnErrorSampleRate: 1.0,
      integrations: [Sentry.replayIntegration()],
    });
  } else {
    Sentry.init({
      dsn: environment.sentryUrl,
      normalizeDepth: 0,
      environment: environment.name,
      ignoreErrors: [
        'Non-Error exception captured',
      ],
    });
  }
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
